module.exports = __webpack_public_path__ + "img/MINI_PROGRAM.ffef663f.svg";